export enum DateInterval {
  ONE_MINUTE = '1min',
  FIVE_MINUTES = '5min',
  TEN_MINUTES = '10min',
  FIFTEEN_MINUTES = '15min',
  ONE_HOUR = '1h',
  ONE_DAY = '1d'
}

export default DateInterval
